import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/PartEcommerceStatus'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class PartEcommerceStatusStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "PartEcommerceStatusStore",
			variables: true,
		})
	}
}

export async function load_PartEcommerceStatus(params) {
  await initClient()

	const store = new PartEcommerceStatusStore()

	await store.fetch(params)

	return {
		PartEcommerceStatus: store,
	}
}
